import { useState } from "react";
import { useForm } from "react-hook-form";
import { RolPermission } from "../rol.Dto";

export const useCreateRol = () => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const useFormRol = useForm<RolPermission>();

  return { openDrawer, setOpenDrawer, useFormRol };
};


